import React, { useState, useEffect } from "react";

import { currentStudentDb, formerStudentsDb } from "../../../db/dbClasses";

import NumberedList from "../../Miscellaneous/NumberedList.component";
import Header from "../../Miscellaneous/Header.component";
import SubHeader from "../../Miscellaneous/SubHeader.component";

import { BoxDiv } from "../../Miscellaneous/FancyDiv.component";

import CardDeck from "react-bootstrap/CardDeck";

export default function Students() {
  const [formerStudents, setFormerStudents] = useState([]);
  const [currentStudents, setCurrentStudents] = useState([]);

  const getData = async () => {
    let _former = await formerStudentsDb.read();
    let _current = await currentStudentDb.read();
    setFormerStudents(_former);
    setCurrentStudents(_current);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="p-0 font-open-sans" style={{ minHeight: "100vh" }}>
      <Header content="Undergraduate and Graduate Students" />
      <BoxDiv>
        <div className="w-100 p-5 pt-2">
          <SubHeader id="current" content="Current Students" />
          <div className="w-100 mx-auto p-4">
            <CardDeck>
              <NumberedList list={currentStudents} searchKey="contents" />
            </CardDeck>
          </div>
          <SubHeader id="former" content="Former Students" />
          <div className="w-100 mx-auto p-4">
            <CardDeck>
              <NumberedList list={formerStudents} searchKey="contents" />
            </CardDeck>
          </div>
        </div>
      </BoxDiv>
    </div>
  );
}
